module.exports = __webpack_public_path__ + "img/dribbble.57589c02.svg";